(() => {
 'use strict';
 let cleanup;
 function mount(){
  cleanup?.();
  const header=document.querySelector('.ni-minimal-header'),section=header?.closest('.shopify-section');
  if(!section)return;
  let maxScroll=Math.max(0,document.documentElement.scrollHeight-window.innerHeight);
  const position=()=>Math.max(0,Math.min(maxScroll,window.scrollY));
  let last=position(),travel=0,direction=0,frame=0,height=section.offsetHeight,hidden=false,offset=-1;
  section.classList.remove('ni-hdr-wrap','ni-hdr-hide');
  section.classList.add('ni-scroll-header');
  section.style.removeProperty('--ni-header-shift');
  const locked=()=>document.body.classList.contains('ni-bag-open')||document.body.style.overflow==='hidden'||!!document.querySelector('dialog[open]')||!!header.querySelector(':focus-visible,[aria-expanded="true"]');
  function notify(){window.dispatchEvent(new Event('ni:header-change'));}
  function syncOffset(){const next=hidden?0:height;if(next===offset)return;offset=next;document.documentElement.style.setProperty('--ni-hdr-off',next+'px');notify();}
  function show(value){const next=!value;if(hidden===next)return;hidden=next;section.classList.toggle('is-scroll-hidden',hidden);syncOffset();}
  function update(){
   frame=0;const y=position(),delta=y-last;last=y;
   if(y<=height||locked()){travel=0;show(true);return;}
   const next=Math.sign(delta);if(!next)return;
   if(next!==direction){direction=next;travel=0;}
   travel+=Math.abs(delta);
   if(travel>=12){show(direction<0);travel=0;}
  }
  const scroll=()=>{if(!frame)frame=requestAnimationFrame(update);};
  const reveal=()=>{show(true);last=position();travel=0;};
  const unlock=()=>{const lock=locked(),was=section.classList.contains('is-scroll-locked');section.classList.toggle('is-scroll-locked',lock);if(lock)reveal();if(lock!==was)notify();};
  const resize=()=>{const next=section.offsetHeight;if(next!==height){height=next;syncOffset();}};
  const transition=e=>{if(e.target===section&&e.propertyName==='transform')notify();};
  const observe=new MutationObserver(unlock);
  observe.observe(document.body,{attributes:true,attributeFilter:['class','style']});
  document.querySelectorAll('dialog').forEach(el=>observe.observe(el,{attributes:true,attributeFilter:['open']}));
  observe.observe(header,{attributes:true,subtree:true,attributeFilter:['aria-expanded']});
  const sizes=new ResizeObserver(resize);sizes.observe(section);
  const bounds=()=>{maxScroll=Math.max(0,document.documentElement.scrollHeight-window.innerHeight);last=position();};
  const pageSize=new ResizeObserver(bounds);pageSize.observe(document.body);
  window.addEventListener('resize',bounds,{passive:true});
  window.addEventListener('scroll',scroll,{passive:true});
  window.addEventListener('pageshow',reveal);
  section.addEventListener('focusin',reveal);
  section.addEventListener('transitionend',transition);
  syncOffset();unlock();
  cleanup=()=>{cancelAnimationFrame(frame);observe.disconnect();sizes.disconnect();pageSize.disconnect();window.removeEventListener('resize',bounds);window.removeEventListener('scroll',scroll);window.removeEventListener('pageshow',reveal);section.removeEventListener('focusin',reveal);section.removeEventListener('transitionend',transition);section.classList.remove('ni-scroll-header','is-scroll-hidden','is-scroll-locked');};
 }
 mount();document.addEventListener('shopify:section:load',mount);
})();
